import React from 'react'
import '../styles/article.css'

const EchoesCH6 = () => {
    return (
        <div className='echoes-chapter'>
            <h1 className='ec-h1'>Chapter 6: The Bridge to Dreams</h1>


            <p>The theater lobby buzzed with a quiet hum of parents and performers exchanging
                congratulations, but our small group lingered near the doors, reluctant to let the
                moment end. Barbara turned to Cora, her voice soft with curiosity. “So, how did
                Stoney end up at Belmont? I know getting into a school like that isn’t easy.”</p>
            <p>Cora’s face brightened, though her eyes glistened with a depth of emotion that spoke
                to the weight of the journey. “It all started with a website called Accoladi.com. Have
                you heard of it?”</p>
            <p>Barbara and I shook our heads, and Cora leaned in, her voice trembling with both
                pride and disbelief. “Last year, during All-State Chorus weekend, one of Stoney’s
                instructors suggested it. He said it was a way for students to showcase their talent to
                colleges across the country. For less than $40 a year, we set up a profile with videos of
                Stoney’s performances and some of his original songs.”</p>


            <p>She paused, swallowing hard. “At first, nothing happened. Those weeks felt like an
                eternity. I wondered if we had made a mistake—if maybe we were dreaming too big.
                But then, about six weeks later, the emails started coming. Schools like Berklee in
                Boston, the University of Miami, and Belmont in Nashville—they all wanted to
                know more about him.”</p>
            <p>Barbara leaned in, captivated. “So, Belmont recruited him through this site?”</p>
            <p>Cora nodded, her hands clasped tightly around her program as if it were a lifeline.
                “They invited us down for a visit. Stoney fell in love with the campus and Nashville.
                Belmont offered him a scholarship, and thanks to Accoladi.com, we also found
                non-institutional scholarships to help cover the cost. Now, it’s actually cheaper for
                him to go there than to stay in Iowa.”</p>


            <p>Barbara jotted the website name in her program, her expression one of quiet
                determination. “A-C-C-O-L-A-D-I. Got it. I’m looking this up during lunch.”</p>
            <p>I couldn’t help but smile. “Barbara’s going to have Ebony on that site before we finish
                dessert.”</p>
            <p>Cora laughed, though her laughter carried the weight of someone who had
                weathered countless storms to reach this moment. “It’s been a blessing for us.
                Stoney has big dreams, and now he has the chance to chase them.”</p>

            <p>Barbara reached out, clasping Cora’s shoulder in a gesture of quiet encouragement.
                “And with his talent, I have no doubt he’ll catch them.”</p>
            <p>As we stepped into the crisp afternoon air, the city streets humming with life around
                us, I found myself lost in thought. There was something extraordinary about
                Stoney’s story—not just the talent that had brought him here, but the quiet
                determination of a mother who had dared to believe in something bigger than the
                life she’d always known.</p>
            <p>For the first time in what felt like days, I felt a flicker of hope for the future. Maybe it
                was the way the sun seemed to hang just a little lower in the sky, casting everything
                in a warm, golden glow. Or maybe it was the way Cora spoke of Stoney, her voice rich
                with the kind of love that could move mountains. Whatever it was, I couldn’t help
                but feel that the best was yet to come—for all of us.</p>

        </div>
    )
}

export default EchoesCH6